import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { LeftNavigation } from '@core/navigation/models/left-navigation/left-navigation.type';

const actionScope = '[Navigation]';

export class SetActiveTopNavigation {
  static readonly type = `${actionScope} Set Active Top Navigation`;

  constructor(public navigation: TopNavigationPath) {}
}

export class SetActiveLeftNavigation {
  static readonly type = `${actionScope} Set Active Left Navigation`;

  constructor(public navigationId: string) {}
}

export class SetLeftNavigation {
  static readonly type = `${actionScope} Set Left Navigation`;

  constructor(public leftNavigation: LeftNavigation) {}
}

export class SetRedirectLeftNavigation {
  static readonly type = `${actionScope} Set Redirect Left Navigation`;

  constructor(public navigationId: string) {}
}

export class SetRedirectTopNavigation {
  static readonly type = `${actionScope} Set Redirect Top Navigation`;

  constructor(public topNavigationPath: TopNavigationPath) {}
}

export class UpdateTopNavigationItems {
  static readonly type = `${actionScope} Update Navigation Items`;
}

export class ResetTopNavigationItemsCollapsedState {
  static readonly type = `${actionScope} Reset Top Navigation Items Collapsed State`;
}
